import type { Product, ProductStatus, VatRate } from './types';

// Q-T156 (2026-07-28): a `PRODUCT_CATEGORIES` hardcoded mock-lista TÖRÖLVE.
// Hat kitalált angol kódot (`power_tool`, `hand_tool`, …) tartalmazott, amelyek
// a valós adatban sehol nem léteznek — a KGC élő kategória-fája
// (`GET /products-direct/categories`): CAT-KISGEP › CAT-FURO / CAT-CSISZ,
// CAT-KERT, ACC-AKKU, ACC-FOGYO, ACC-VEDO. Emiatt a create/edit elvesztette a
// választást, a lista/részletező badge nyers kódot mutatott, a kategória-szűrő
// pedig sosem adott találatot. Az egyetlen forrás mostantól a `useProductCategories()`.

export const PRODUCT_STATUSES: { value: ProductStatus; label: string; color: string }[] = [
  {
    value: 'active',
    label: 'Aktív',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  {
    value: 'inactive',
    label: 'Inaktív',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  },
  {
    value: 'discontinued',
    label: 'Kifutott',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
];

export const VAT_RATES: { value: VatRate; label: string }[] = [
  { value: 27, label: '27%' },
  { value: 18, label: '18%' },
  { value: 5, label: '5%' },
  { value: 0, label: '0% (Fordított ÁFA)' },
];

export const MOCK_SUPPLIERS = [
  { id: 's-001', name: 'Makita Magyarország Kft.', code: 'MAKITA' },
  { id: 's-002', name: 'Bosch Kft.', code: 'BOSCH' },
  { id: 's-003', name: 'DeWalt Hungary', code: 'DEWALT' },
  { id: 's-004', name: 'Milwaukee Tool', code: 'MILW' },
  { id: 's-005', name: 'Egyéb beszállító', code: 'OTHER' },
];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 'prod-001',
    status: 'active',
    category: 'power_tool',
    sku: 'MAK-DHP481',
    barcode: '0088381678940',
    name: 'Makita DHP481RTJ akkus ütvefúró-csavarozó',
    shortName: 'DHP481RTJ',
    description:
      '18V LXT akkumulátoros ütvefúró-csavarozó 2x5.0Ah akkuval, gyorstöltővel, MAKPAC kofferben',
    brand: 'Makita',
    model: 'DHP481RTJ',
    purchasePrice: 89000,
    sellingPriceNet: 125000,
    sellingPriceGross: 158750,
    vatRate: 27,
    marginPercent: 40.4,
    stockQuantity: 8,
    reservedQuantity: 2,
    availableQuantity: 6,
    minStockLevel: 3,
    reorderQuantity: 5,
    location: 'A-02-03',
    supplier: MOCK_SUPPLIERS[0],
    lastPurchaseDate: '2026-01-10',
    lastPurchasePrice: 89000,
    imageUrl: '/images/products/dhp481.jpg',
    thumbnailUrl: '/images/products/dhp481-thumb.jpg',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2026-01-15T14:30:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-002',
    status: 'active',
    category: 'power_tool',
    sku: 'MAK-GA5050',
    barcode: '0088381095341',
    name: 'Makita GA5050 sarokcsiszoló 125mm 1300W',
    shortName: 'GA5050',
    description: '1300W teljesítményű sarokcsiszoló 125mm tárcsaátmérővel, SJS technológiával',
    brand: 'Makita',
    model: 'GA5050',
    purchasePrice: 32000,
    sellingPriceNet: 45000,
    sellingPriceGross: 57150,
    vatRate: 27,
    marginPercent: 40.6,
    stockQuantity: 15,
    reservedQuantity: 0,
    availableQuantity: 15,
    minStockLevel: 5,
    reorderQuantity: 10,
    location: 'A-03-01',
    supplier: MOCK_SUPPLIERS[0],
    lastPurchaseDate: '2026-01-05',
    lastPurchasePrice: 32000,
    createdAt: '2024-02-20T08:00:00Z',
    updatedAt: '2026-01-10T11:15:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-003',
    status: 'active',
    category: 'rental_equipment',
    sku: 'BERG-HILTI-TE60',
    barcode: '7613023579120',
    name: 'Hilti TE 60-ATC-AVR kombikalapács (bérgép)',
    shortName: 'TE 60 bérgép',
    description: 'Professzionális SDS-max kombikalapács bontáshoz és fúráshoz',
    brand: 'Hilti',
    model: 'TE 60-ATC-AVR',
    purchasePrice: 450000,
    sellingPriceNet: 0,
    sellingPriceGross: 0,
    vatRate: 27,
    marginPercent: 0,
    stockQuantity: 3,
    reservedQuantity: 1,
    availableQuantity: 2,
    minStockLevel: 1,
    reorderQuantity: 0,
    location: 'B-01-01',
    rentalDailyRate: 8500,
    rentalWeeklyRate: 45000,
    rentalMonthlyRate: 140000,
    rentalDepositAmount: 150000,
    createdAt: '2023-06-01T10:00:00Z',
    updatedAt: '2026-01-12T09:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-004',
    status: 'active',
    category: 'accessory',
    sku: 'MAK-B-07967',
    barcode: '0088381438629',
    name: 'Makita B-07967 fúrószár készlet HSS-G 19db',
    shortName: 'HSS-G készlet 19db',
    description: '19 darabos HSS-G fúrószár készlet fémhez, 1-10mm',
    brand: 'Makita',
    model: 'B-07967',
    purchasePrice: 4500,
    sellingPriceNet: 7500,
    sellingPriceGross: 9525,
    vatRate: 27,
    marginPercent: 66.7,
    stockQuantity: 45,
    reservedQuantity: 5,
    availableQuantity: 40,
    minStockLevel: 20,
    reorderQuantity: 30,
    location: 'C-01-05',
    supplier: MOCK_SUPPLIERS[0],
    lastPurchaseDate: '2026-01-08',
    lastPurchasePrice: 4500,
    createdAt: '2024-03-10T10:00:00Z',
    updatedAt: '2026-01-08T15:20:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-005',
    status: 'active',
    category: 'consumable',
    sku: 'BOSCH-DISCO-125',
    barcode: '3165140219471',
    name: 'Bosch vágókorong 125x1mm inox (10db)',
    shortName: 'Vágókorong 125mm',
    description: 'Rozsdamentes acélhoz és fémhez, 10db/csomag',
    brand: 'Bosch',
    model: '2608600219',
    purchasePrice: 1800,
    sellingPriceNet: 2900,
    sellingPriceGross: 3683,
    vatRate: 27,
    marginPercent: 61.1,
    stockQuantity: 120,
    reservedQuantity: 0,
    availableQuantity: 120,
    minStockLevel: 50,
    reorderQuantity: 100,
    location: 'C-02-01',
    supplier: MOCK_SUPPLIERS[1],
    lastPurchaseDate: '2026-01-12',
    lastPurchasePrice: 1800,
    createdAt: '2024-01-05T08:00:00Z',
    updatedAt: '2026-01-12T10:30:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-006',
    status: 'active',
    category: 'spare_part',
    sku: 'MAK-CB430',
    barcode: '0088381419642',
    name: 'Makita CB-430 szénkefe pár',
    shortName: 'CB-430 szénkefe',
    description: 'Eredeti Makita szénkefe BGA452, BHP451, BSS610 stb. gépekhez',
    brand: 'Makita',
    model: 'CB-430',
    purchasePrice: 850,
    sellingPriceNet: 1500,
    sellingPriceGross: 1905,
    vatRate: 27,
    marginPercent: 76.5,
    stockQuantity: 35,
    reservedQuantity: 0,
    availableQuantity: 35,
    minStockLevel: 15,
    reorderQuantity: 25,
    location: 'D-01-02',
    supplier: MOCK_SUPPLIERS[0],
    lastPurchaseDate: '2025-12-20',
    lastPurchasePrice: 850,
    createdAt: '2024-04-01T10:00:00Z',
    updatedAt: '2025-12-20T14:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-007',
    status: 'inactive',
    category: 'power_tool',
    sku: 'DEWALT-DCD791',
    barcode: '5035048645154',
    name: 'DeWalt DCD791D2 akkus fúró-csavarozó',
    shortName: 'DCD791D2',
    description: '18V XR akkus fúró-csavarozó 2x2.0Ah akkuval, töltővel',
    brand: 'DeWalt',
    model: 'DCD791D2',
    purchasePrice: 65000,
    sellingPriceNet: 89000,
    sellingPriceGross: 113030,
    vatRate: 27,
    marginPercent: 36.9,
    stockQuantity: 0,
    reservedQuantity: 0,
    availableQuantity: 0,
    minStockLevel: 2,
    reorderQuantity: 3,
    location: 'A-01-05',
    supplier: MOCK_SUPPLIERS[2],
    lastPurchaseDate: '2025-08-15',
    lastPurchasePrice: 65000,
    createdAt: '2024-05-10T10:00:00Z',
    updatedAt: '2025-10-01T09:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-008',
    status: 'discontinued',
    category: 'hand_tool',
    sku: 'OLD-HAMMER-500',
    name: 'Kalapács 500g (kifutott)',
    shortName: 'Kalapács 500g',
    description: 'Régi típusú kalapács - már nem rendelhető',
    purchasePrice: 2000,
    sellingPriceNet: 3500,
    sellingPriceGross: 4445,
    vatRate: 27,
    marginPercent: 75,
    stockQuantity: 2,
    reservedQuantity: 0,
    availableQuantity: 2,
    minStockLevel: 0,
    reorderQuantity: 0,
    location: 'E-05-01',
    createdAt: '2022-01-01T10:00:00Z',
    updatedAt: '2024-06-01T10:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-009',
    status: 'active',
    category: 'rental_equipment',
    sku: 'BERG-MAK-HR2470',
    barcode: '0088381082563',
    name: 'Makita HR2470 SDS-Plus fúrókalapács (bérgép)',
    shortName: 'HR2470 bérgép',
    description: 'Könnyű fúrókalapács lakásfelújításhoz, 780W, 2.4J',
    brand: 'Makita',
    model: 'HR2470',
    purchasePrice: 42000,
    sellingPriceNet: 0,
    sellingPriceGross: 0,
    vatRate: 27,
    marginPercent: 0,
    stockQuantity: 5,
    reservedQuantity: 3,
    availableQuantity: 2,
    minStockLevel: 2,
    reorderQuantity: 0,
    location: 'B-01-03',
    rentalDailyRate: 3500,
    rentalWeeklyRate: 18000,
    rentalMonthlyRate: 55000,
    rentalDepositAmount: 40000,
    supplier: MOCK_SUPPLIERS[0],
    createdAt: '2023-03-15T10:00:00Z',
    updatedAt: '2026-01-18T08:30:00Z',
    createdBy: 'admin',
  },
  {
    id: 'prod-010',
    status: 'active',
    category: 'power_tool',
    sku: 'MILW-M18FPD2',
    barcode: '4002395149827',
    name: 'Milwaukee M18 FPD2-502X FUEL ütvefúró',
    shortName: 'M18 FPD2',
    description: 'M18 FUEL ütvefúró-csavarozó 2x5.0Ah akkuval, HD Box-ban',
    brand: 'Milwaukee',
    model: 'M18 FPD2-502X',
    purchasePrice: 115000,
    sellingPriceNet: 159000,
    sellingPriceGross: 201930,
    vatRate: 27,
    marginPercent: 38.3,
    stockQuantity: 4,
    reservedQuantity: 1,
    availableQuantity: 3,
    minStockLevel: 2,
    reorderQuantity: 3,
    location: 'A-01-01',
    supplier: MOCK_SUPPLIERS[3],
    lastPurchaseDate: '2026-01-02',
    lastPurchasePrice: 115000,
    createdAt: '2024-08-01T10:00:00Z',
    updatedAt: '2026-01-02T11:00:00Z',
    createdBy: 'admin',
  },
];
